(() => {
  const KEY = 'auren_wishlist_v1';
  const MOBILE_QUERY = '(max-width: 749px)';
  const WISHLIST_URL = '/pages/favoriter';
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg>';
  const mobileMedia = window.matchMedia(MOBILE_QUERY);
  let queued = false;

  function count() {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.length : 0;
    } catch (error) {
      return 0;
    }
  }

  function accountTarget() {
    const root = document.querySelector('#header-group, header-component, header');
    if (!root) return null;
    return root.querySelector('.account-button') || root.querySelector('shopify-account')?.closest('.account-button') || null;
  }

  function removeHeaderHeart() {
    document.querySelectorAll('.auren-wishlist-header-button').forEach((heart) => heart.remove());
  }

  function placeDesktopHeart() {
    const account = accountTarget();
    if (!account) return;
    let heart = document.querySelector('.auren-wishlist-header-button');
    if (!heart || heart.tagName !== 'A') {
      heart?.remove();
      heart = document.createElement('a');
      heart.href = WISHLIST_URL;
      heart.className = 'auren-wishlist-header-button header-actions__action';
      heart.setAttribute('aria-label', 'Favoriter');
      heart.innerHTML = HEART + '<span class="auren-wishlist-count" aria-hidden="true"></span>';
    }
    const badge = heart.querySelector('.auren-wishlist-count');
    const total = count();
    if (badge) {
      badge.textContent = String(total);
      badge.classList.toggle('has-items', total > 0);
    }
    if (heart.nextElementSibling !== account) account.insertAdjacentElement('beforebegin', heart);
  }

  function placeMobileMenuItem() {
    const menu = document.querySelector('.header-drawer--mobile .menu-drawer__menu.has-submenu') || document.querySelector('#Details-menu-drawer-container .menu-drawer__menu.has-submenu');
    if (!menu || menu.querySelector('[data-auren-mobile-wishlist]')) return;
    const item = document.createElement('li');
    item.dataset.aurenMobileWishlist = '';
    item.className = 'menu-drawer__list-item';
    item.style.setProperty('--menu-drawer-animation-index', String(menu.children.length + 1));
    item.innerHTML = '<a href="' + WISHLIST_URL + '" class="menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset" aria-label="Favoriter"><span class="menu-drawer__menu-item-text wrap-text">FAVORITER</span></a>';
    menu.appendChild(item);
  }

  function removeMobileMenuItem() {
    document.querySelectorAll('[data-auren-mobile-wishlist]').forEach((item) => item.remove());
  }

  function applyPlacement() {
    queued = false;
    if (mobileMedia.matches) {
      removeHeaderHeart();
      placeMobileMenuItem();
    } else {
      removeMobileMenuItem();
      placeDesktopHeart();
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(applyPlacement);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyPlacement, { once: true });
  else applyPlacement();

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', (event) => { if (event.key === KEY) schedule(); });
  document.addEventListener('shopify:section:load', schedule);
  if (typeof mobileMedia.addEventListener === 'function') mobileMedia.addEventListener('change', schedule);
  else if (typeof mobileMedia.addListener === 'function') mobileMedia.addListener(schedule);
})();